import { useLayoutEffect } from 'react';

// Reference: https://github.com/mui-org/material-ui/blob/27471b4564eb40ff769352d73a29938d25804e45/packages/material-ui/src/utils/getScrollbarSize.js
export const getScrollbarSize = () => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';

  document.body.appendChild(scrollDiv);
  const scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return scrollbarSize;
};

export const useScrollbarWidthOffset = (container = document.body) => {
  useLayoutEffect(() => {
    const { paddingRight } = window.getComputedStyle(container);
    const scrollbarSize = getScrollbarSize();
    const paddingRightInteger = parseInt(paddingRight, 10);
    container.style.paddingRight = `${paddingRightInteger + scrollbarSize}px`;

    return () => {
      container.style.paddingRight = paddingRight;
    };
  }, [container]);
};
